<div class="container">
    <div class="container-row">
        <div class="back-button-container">
            <button (click)="goBackOnce()">back</button>
        </div>
        <div class="container">
            <h1>Schedule</h1>
        </div>
    </div>

    <!-- Develop this div appropriately -->
    <div class="card-container">
        <a class="card" routerLink="facilities/schedule/display-schedule" routerLinkActive="active" (click)="goToPage('display-schedule')">
            <img src="assets/images/clock.png" alt="Display Schedule">
        
            <span>Display Schedule</span>
          </a>
        
          <a class="card" routerLink="facilities/schedule/generate-schedule" routerLinkActive="active" (click)="goToPage('generate-schedule')">
              <img src="assets/images/calendar.png" alt="Generate New Schedule">
        
            <span>Schedule Suggested</span>
          </a>
    </div>
</div>